import { useLocation, useNavigate, useOutletContext } from 'react-router'
import { GoChevronLeft } from 'react-icons/go'

import Spinner from '../loading/Spinner'
import Filler from '../utils/Filler'
import NotFoundSettings from '../fallback/NotFoundSettings'
import Account from './Account'
import Accessibility from './Accessibility'
import Information from './Information'
import Password from './Password'
import Deactivate from './Deactivate'
import Display from './Display'

const titles = {
  account: 'Your account',
  monetization: 'Monetization',
  premium: 'Premium',
  subscriptions: 'Creator subscriptions',
  accessibility: 'Accessibility, display and languages',
  security: 'Security and account access',
  privacy: 'Privacy and safety',
  notifications: 'Notifications',
  resources: 'Additional resources',
  help: 'Help center',
  information: 'Account information',
  password: 'Change password',
  deactivate: 'Deactivate your account',
  display: 'Display',
}

interface ContextProps {
  username: string
  email: string
}

const SettingsWindow: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { username, email } = useOutletContext<ContextProps>()

  const pathnameParts = location.pathname.split('/')
  const key = pathnameParts[2]
  const title = key in titles ? titles[key as keyof typeof titles] : 'Not found'

  let main = (
    <div className="flex h-full w-full items-center justify-center">
      <Spinner />
    </div>
  )

  if (title === 'Not found') {
    main = <NotFoundSettings />
  }

  if (key === 'account') {
    main = (
      <div className="h-full w-full">
        <Account />
      </div>
    )
  } else if (key === 'accessibility') {
    main = (
      <div className="h-full w-full">
        <Accessibility />
      </div>
    )
  } else if (key === 'information') {
    main = (
      <div className="h-full w-full">
        <Information username={username} email={email} />
      </div>
    )
  } else if (key === 'password') {
    main = (
      <div className="h-full w-full">
        <Password />
      </div>
    )
  } else if (key === 'deactivate') {
    main = (
      <div className="h-full w-full">
        <Deactivate />
      </div>
    )
  } else if (key === 'display') {
    main = (
      <div className="h-full w-full">
        <Display />
      </div>
    )
  } else {
    main = (
      <div className="flex h-full w-full flex-col text-sm">
        <div className="flex h-[50px] items-center pl-[10px] text-xl font-semibold">
          <div className="flex items-center">
            <button
              type="button"
              className="hover-main mr-[10px] flex h-[30px] w-[30px] items-center justify-center rounded-full"
              onClick={() => {
                navigate('/settings')
              }}
            >
              <GoChevronLeft />
            </button>
            <h1>{title}</h1>
          </div>
        </div>
        <div className="text-sub flex h-full w-full items-center justify-center">
          Selected settings option is not yet available.
        </div>
      </div>
    )
  }

  return (
    <div className="flex h-full w-full flex-col">
      <Filler />
      {main}
    </div>
  )
}

export default SettingsWindow
